import { Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { BlurReveal } from "@/components/effects/blur-reveal";
import { AuroraBackground } from "@/components/aceternity/aurora-background";
import { NoiseBackground } from "@/components/aceternity/noise-background";
import { TypewriterEffect } from "@/components/aceternity/typewriter-effect";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-bg overflow-hidden">
      <AuroraBackground />
      <NoiseBackground opacity={0.08} />
      <div
        aria-hidden
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[85%] h-[720px] pointer-events-none"
        style={{ background: "radial-gradient(ellipse at top, rgba(201,169,106,0.22), transparent 60%)" }}
      />

      <main className="relative min-h-screen flex flex-col items-center justify-center px-6 py-24 text-center">
        <BlurReveal>
          <div className="mb-8 flex items-center gap-3">
            <img src="/logo.png" alt="" className="h-11 w-11 rounded-xl" />
            <span className="font-bold tracking-[0.18em] text-lg">ARABISE</span>
          </div>
        </BlurReveal>

        <BlurReveal delay={0.1}>
          <Badge variant="accent" className="mb-6 gap-2">
            <Sparkles className="w-3 h-3" /> Coming soon
          </Badge>
        </BlurReveal>

        <BlurReveal delay={0.15}>
          <div
            className="mb-5 text-2xl md:text-3xl text-accent"
            style={{ fontFamily: "'Noto Sans Arabic', serif", direction: "rtl" }}
          >
            حِقبة جديدة
          </div>
        </BlurReveal>

        <BlurReveal delay={0.2}>
          <h1 className="mx-auto max-w-4xl text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight leading-[1.05]">
            A <span className="text-accent">new era</span>.
          </h1>
        </BlurReveal>

        <BlurReveal delay={0.3}>
          <div className="mt-8 mx-auto max-w-2xl">
            <TypewriterEffect
              words={[
                { text: "The" },
                { text: "community" },
                { text: "beta" },
                { text: "is" },
                { text: "coming.", className: "text-accent" }
              ]}
              className="text-lg md:text-2xl font-medium text-fg-2"
              cursorClassName="bg-accent"
            />
          </div>
        </BlurReveal>

        <BlurReveal delay={0.5}>
          <p className="mt-10 mx-auto max-w-xl text-sm md:text-base text-fg-3 leading-relaxed">
            We're rebuilding Arabise from the ground up. Everyone learning Arabic
            — school, self-taught, curious — will get in.
            Follow along and get first access when the beta opens.
          </p>
        </BlurReveal>

        <BlurReveal delay={0.65}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <a
              href="mailto:support@arabise.co.uk?subject=Arabise%20Community%20Beta%20-%20count%20me%20in"
              className="inline-flex items-center gap-2 rounded-full border border-accent bg-accent px-6 py-3 text-sm font-semibold text-bg hover:brightness-110 transition"
            >
              Get notified <Sparkles className="w-4 h-4" />
            </a>
            <a
              href="https://www.tiktok.com/@arabise"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-line bg-bg-2 px-6 py-3 text-sm font-semibold text-fg hover:border-accent-lo transition"
            >
              Follow on TikTok
            </a>
          </div>
        </BlurReveal>

        <BlurReveal delay={0.85}>
          <div className="mt-16 flex items-center gap-8 text-xs uppercase tracking-widest text-fg-3">
            <span>Arabic · AI · Arabise</span>
          </div>
        </BlurReveal>
      </main>

      <footer className="relative py-8 text-center text-xs text-fg-3">
        © 2026 Arabise. Made in the UK.
      </footer>
    </div>
  );
}
